// Serves Storyblok images from its image CDN at high quality, sized per width.
const QUALITY = 90;

// Existing focal/aspect crop (e.g. hero): keep ratio and filters, scale to width.
const CROP = /\/m\/(\d+)x(\d+)(\/filters:[^/]+)?$/;

// Storyblok URLs embed the source size: /f/<space>/<w>x<h>/<hash>/<file>.
const NATURAL = /\/f\/\d+\/(\d+)x/;

export function storyblokImage(src: string, width: number): string {
  if (!src) return src;

  // Google avatars size via the =s<px> suffix.
  if (src.includes("googleusercontent.com")) {
    return /=s\d+/.test(src) ? src.replace(/=s\d+/, `=s${width}`) : `${src}=s${width}`;
  }

  if (!src.includes("a.storyblok.com")) return src;
  // The service can't resize SVGs — vary the (stripped-on-fetch) fragment so
  // Next sees the loader honour width.
  if (/\.svg(\?|#|$)/i.test(src)) return `${src}#w${width}`;

  // Never exceed the source width — Storyblok would upscale it.
  const natural = src.match(NATURAL);
  const w = natural ? Math.min(width, Number(natural[1])) : width;

  const crop = src.match(CROP);
  if (crop) {
    const [full, cw, ch, filters = `/filters:quality(${QUALITY})`] = crop;
    const height = Math.round(w * (Number(ch) / Number(cw)));
    const base = src.slice(0, src.length - full.length);
    return `${base}/m/${w}x${height}${filters}`;
  }

  return `${src}/m/${w}x0/filters:quality(${QUALITY})`;
}

export default function storyblokImageLoader({
  src,
  width,
}: {
  src: string;
  width: number;
  quality?: number;
}): string {
  return storyblokImage(src, width);
}
